import template from './index.html'
import { DetailMealLogController } from './controller'

export const vsName = 'machineMealLog'
export const vsNgType = 'directive'

machineMealLogDirective.$inject = []
export function machineMealLogDirective() {
  return {
    restrict: 'E',
    templateUrl: template,
    controller: DetailMealLogController,
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      machineId: '=',
      machine: '='
    }
  }
}